// @flow

export { BoletoPage as default } from './boleto-page';
